/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';

/**
 * A download icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 * @returns {React.ReactElement}
 */
export default function ShareIcon({ className, size = 'small', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // @ts-ignore
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
        color: 'currentColor',
      }}
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      {...rest}
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="currentColor" fillRule="nonzero">
          <path d="M13 2.5a2.5 2.5 0 11-1.662 4.367L7.396 9.283a2.5 2.5 0 01-.002 1.44l3.829 2.519a2.5 2.5 0 11-.548.838l-3.76-2.473A2.5 2.5 0 116.921 8.4l3.815-2.338A2.5 2.5 0 0113 2.5zm0 11a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-8-5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm8-5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"></path>
        </g>
      </g>
      s
    </svg>
  );
}
